import {buildPredictionTooltip} from '../../utils/buildPredictionTooltip';
import {Tooltip} from '../Tooltip/Tooltip';

const ROW_CLASS = 'inline-flex items-center gap-2';

const PERCENTAGE_CLASS =
  'min-w-12 text-center rounded-sm bg-[var(--color-mira-gray-100)] px-1.5 py-0.5 text-2xs font-medium leading-4 text-white tabular-nums whitespace-nowrap';

const LABEL_CLASS =
  'text-sm font-normal leading-5 text-[var(--color-text-primary)] whitespace-nowrap';

interface PredictionBadgeProps {
  readonly percentage: number;
  readonly label: string;
  readonly willNeed: boolean;
}

export function PredictionBadge(props: PredictionBadgeProps) {
  const showPercentage = props.percentage > 0;
  const tooltipContent = showPercentage
    ? buildPredictionTooltip(props.percentage, props.willNeed)
    : props.label;
  const percentageLabel = props.percentage.toString().concat('%');

  return (
    <Tooltip content={tooltipContent}>
      <span className={ROW_CLASS}>
        {showPercentage ? <span className={PERCENTAGE_CLASS}>{percentageLabel}</span> : null}
        <span className={LABEL_CLASS}>{props.label}</span>
      </span>
    </Tooltip>
  );
}
